import React, { useState, useRef, useEffect, ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import {
  Box,
  Button,
  FormControlLabel,
  Link,
  Modal,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
} from "@mui/material";
import "../../../../../../../formLayout.scss";
import SlidingPanel from "react-sliding-side-panel";
import RKTextField from "../../../../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../../../../Supporting files/SearchDropdown/SearchDropdown";
import SelectDropdown from "../../../../../../../Supporting files/SelectDropdown/SelectDropdown";
import SpocTable from "../../../../../../../Components/Broker/SPOCTable/SpocTable";
import LocationDetail from "../../../../../../../Components/Broker/LocationDetail/LocationDetail";
import LocationTable from "../../../../../../../Components/Broker/LocationTable/LocationTable";
import { GridCloseIcon } from "@mui/x-data-grid/components/icons";

function InsurerDetails() {
  const navigate = useNavigate();
  const [viewTabsStatus, setViewTabsStatus] = React.useState("overview");
  const [insurerName, setInsurerName] = React.useState("Digit");
  const [networkhospurl, setNetworkHospUrl] = React.useState("150");
  const [mobilenumber, setMobileNumber] = React.useState("9874565231");
  const [website, setWebsite] = React.useState("www.digitinsure.com");
  const [minimumAge, setMinimumAge] = React.useState("");
  const [maximumAge, setMaximumAge] = React.useState("");
  const [openContactForm, setOpenContactForm] = React.useState(false);
  const [personalemail, setPersonalEmail] = React.useState(
    "info@digitinsure.com"
  );
  const [locationName, setLocationName] = React.useState(
    "Digit General Insurance"
  );
  const [openPhysicalForm, setOpenPhysicalForm] = React.useState(false);
  const [removeCategory, setRemoveCategory] = React.useState(false);
  const [templateTitle, setTemplateTitle] = React.useState("");
  const [buildingName, setBuildingName] = React.useState("#6, Building");
  const [areaName, setAreaName] = React.useState("Industrial Area");
  const [country, setCountry] = React.useState("India");
  const [State, setState] = React.useState("Punjab");
  const [location, setLocation] = React.useState("Head Office");
  const [addAttatchment, setAddAttatchment] = React.useState("");
  const [module, setModule] = React.useState("");
  const [file, setFile] = React.useState("");
  const [City, setCity] = React.useState("Mohali");
  const [senderEmail, setSenderEmail] = React.useState("");
  const [subjects, setSubjects] = React.useState("");
  const [respondent, setRespondent] = React.useState("");
  const [zipcode, setZipcode] = React.useState("335512");
  const [toggle, setToggle] = React.useState(true);
  const [contactID, setContactID] = React.useState("");
  const [openLocation, setopenLocation] = React.useState(false);
  const [openEmail, setopenEmail] = React.useState(false);
  const [sectionStatus, SetSectionStatus] =
    React.useState<string>("personalDetails");
  const [physicalTitle, setPhysicalTitle] = React.useState("");
  const [physicalProduct, setPhysicalProduct] = React.useState("");
  const [physicalType, setPhysicalType] = React.useState("");
  const [physicalsubType, setPhysicalSubType] = React.useState("");
  const [subSection, setSubSection] = React.useState("basicinfo");
  const [locationDetail, setLocationDetail] = React.useState(false);
  const [spocContact, setSpocContact] = React.useState("");
  const [contactName, setContactName] = React.useState("");
  const [jobTitle, setJobTitle] = React.useState("");
  const [contactEmail, setContactEmail] = React.useState("");
  const [contactMobile, setContactMobile] = React.useState("");
  const [contactNumber, setContactNumber] = React.useState("");
  const [currentEmployer, setCurrentEmployer] = React.useState("");
  const [contactOrganization, setContactOrganization] = React.useState("");
  const [contactDepartment, setContactDepartment] = React.useState("");
  const [show, setShow] = useState(false);
  const [formData, setFormData] = React.useState([
    {
      checkbox_status: true,
      check_status: "",
      sr_no: "01",
      Title: "Commercial",
      description:
        "This email is sent to the client when an endorsement raised by them is initiated.",
      actionBtn: "images/edit_icon.svg",
    },
    {
      checkbox_status: false,
      check_status: "",
      sr_no: "2",
      Title: "Non- Commercial",
      description:
        "This email is sent to the client when an endorsement raised by them is initiated.",
      actionBtn: "images/edit_icon.svg",
    },
  ]);
  const location_data = [
    { label: "Regiasted Office", value: "Regiasted Office" },
    { label: "Regional Office", value: "Regional Office" },
    { label: "State Head Office", value: "State Head Office" },
    { label: "City Office", value: "City Office" },
    { label: "City Sub Office", value: "City Sub Office" },
  ];
  const maximumage_data = [
    { key: "25 Years", value: "25 Years" },
    { key: "26 Years", value: "26 Years" },
    { key: "27 Years", value: "27 Years" },
    { key: "28 Years", value: "28 Years" },
    { key: "29 Years", value: "29 Years" },
  ];

  const minimumage_data = [
    { key: "12 Years", value: "12 Years" },
    { key: "13 Years", value: "13 Years" },
    { key: "14 Years", value: "14 Years" },
    { key: "15 Years", value: "15 Years" },
    { key: "16 Years", value: "16 Years" },
  ];
  const [spocData, setSpocData] = React.useState([
    {
      Name: "Kartike Kakkar",
      org: "TCS",
      mobile: "98765 41526",
      emails: "kartike@gmail.com",
      officephone: "011 45785895",
      officeemail: "kartike@evervent.in",
      curruntjobtitle: "Developer",
      Department: "Design",
      curruntemployer: "Evervent",
      actionBtn: "images/edit_icon.svg",
    },
    {
      Name: "Kartike Kakkar",
      org: "TCS",
      mobile: "98765 41526",
      emails: "kartike@gmail.com",
      officephone: "011 45785895",
      officeemail: "kartike@evervent.in",
      curruntjobtitle: "Developer",
      Department: "Design",
      curruntemployer: "Evervent",
      actionBtn: "images/edit_icon.svg",
    },
    {
      Name: "Kartike Kakkar",
      org: "TCS",
      mobile: "98765 41526",
      emails: "kartike@gmail.com",
      officephone: "011 45785895",
      officeemail: "kartike@evervent.in",
      curruntjobtitle: "Developer",
      Department: "Design",
      curruntemployer: "Evervent",
      actionBtn: "images/edit_icon.svg",
    },
    {
      Name: "Kartike Kakkar",
      org: "TCS",
      mobile: "98765 41526",
      emails: "kartike@gmail.com",
      officephone: "011 45785895",
      officeemail: "kartike@evervent.in",
      curruntjobtitle: "Developer",
      Department: "Design",
      curruntemployer: "Evervent",
      actionBtn: "images/edit_icon.svg",
    },
  ]);
  const spoc_contact_data = [
    { key: "EV0065VikasSaini", value: "EV0065 Vikas Saini" },
    { key: "EV0016KartikeKakkar", value: "EV0016 Kartike Kakkar" },
  ];
  const contact_department_data = [
    { key: "Engineering", value: "Engineering" },
    { key: "IT", value: "IT" },
    { key: "Human Resource", value: "Human Resource" },
    { key: "Business Development", value: "Business Development" },
    { key: "Designing", value: "Designing" },
    { key: "Management", value: "Management" },
  ];
  const current_employer_data = [
    { key: "Evervent", value: "Evervent" },
    { key: "Amazon", value: "Amazon" },
    { key: "Infosys", value: "Infosys" },
    { key: "Google", value: "Google" },
    { key: "Microsoft", value: "Microsoft" },
  ];
  const job_title_data = [
    {
      key: "Associate Frontend Developer",
      value: "Associate Frontend Developer",
    },
    { key: "Hr", value: "Hr" },
    { Key: "QA Engineer", value: "QA Engineer" },
  ];
  const contact_organization_data = [
    { key: "Evervent", value: "Evervent" },
    { key: "Amazon", value: "Amazon" },
    { key: "Infosys", value: "Infosys" },
    { key: "Google", value: "Google" },
    { key: "Microsoft", value: "Microsoft" },
  ];
  const ContactID_data = [
    {
      label: "CL-001 Abhishek Arora Evervent",
      value: "CL-001 Abhishek Arora Evervent",
    },
    {
      label: "CL-002 kartike kakkar Evervent",
      value: "CL-002 kartike kakkar Evervent",
    },
    {
      label: "CL-003 Vikas Saini Evervent",
      value: "CL-003 Vikas Saini Evervent",
    },
    {
      label: "CL-004 Rohit Mankotai Evervent",
      value: "CL-004 Rohit Mankotai Evervent",
    },
    {
      label: "CL-005 Rahul Raghuvanshi Evervent",
      value: "CL-005 Rahul Raghuvanshi Evervent",
    },
    {
      label: "CL-006 Umesh Gemini  Evervent",
      value: "CL-006 Umesh Gemini  Evervent",
    },
  ];

  const [emailData, setEmailData] = React.useState([
    {
      sr_no: "1",
      Title: "Endorsement Raised",
      subject:
        "This email is sent to the client when an endorsement raised by them is initiated.",
      actionBtn: "images/edit_icon.svg",
    },
    {
      sr_no: "2",
      Title: "Claimed Solved",
      subject:
        "This email is sent to the client when an endorsement raised by them is initiated.",
      actionBtn: "images/edit_icon.svg",
    },
  ]);

  const [locationData, setLocationData] = React.useState([
    {
      companyName: "Evervent",
      locationType: "Registered Office",
      companyAddress:
        "321, Industrial Area  , Phase 9, Mohali, Punjab, India - 1411111",
      spoc: "SP01 - Satish (9876543210)",
      activePolicies: "5",
      actionBtn: "images/edit_icon.svg",
    },
    {
      companyName: "Evervent",
      locationType: "Head Office",
      companyAddress:
        "321, Industrial Area  , Phase 9, Mohali, Punjab, India - 1411111",
      spoc: "SP01 - Satish (9876543210)",
      activePolicies: "5",
      actionBtn: "images/edit_icon.svg",
    },
    {
      companyName: "Evervent",
      locationType: "RnD Office",
      companyAddress:
        "321, Industrial Area  , Phase 9, Mohali, Punjab, India - 1411111",
      spoc: "SP01 - Satish (9876543210)",
      activePolicies: "5",
      actionBtn: "images/edit_icon.svg",
    },
    {
      companyName: "Evervent",
      locationType: "Front Office",
      companyAddress:
        "321, Industrial Area  , Phase 9, Mohali, Punjab, India - 1411111",
      spoc: "SP01 - Satish (9876543210)",
      activePolicies: "5",
      actionBtn: "images/edit_icon.svg",
    },
    {
      companyName: "Evervent",
      locationType: "Head Office",
      companyAddress:
        "321, Industrial Area  , Phase 9, Mohali, Punjab, India - 1411111",
      spoc: "SP01 - Satish (9876543210)",
      activePolicies: "5",
      actionBtn: "images/edit_icon.svg",
    },
  ]);

  const [physicalData, setPhysicalData] = React.useState([
    {
      checkbox_status: true,
      check_status: "",
      Title: "Iffco-Tokio Claim Intimation Form",
      description: "Lorem ipsum dolor sit alent",
      product: "Group Health",
      type: "Claim",
      subtype: "Cashless",
      actionBtn: "images/edit_icon.svg",
    },
    {
      checkbox_status: true,
      check_status: "",
      Title: "Iffco-Tokio Pre-Authorization Form",
      description: "Lorem ipsum dolor sit alent",
      product: "Group Health",
      type: "Claim",
      subtype: "Cashless",
      actionBtn: "images/edit_icon.svg",
    },
  ]);

  const [checked, setChecked] = useState(false);
  const [checkedOne, setCheckedOne] = useState(false);
  const [checkedTwo, setCheckedTwo] = useState(false);
  const [checkedThree, setCheckedThree] = useState(false);
  const [checkedFour, setCheckedFour] = useState(false);
  const handleCheck = () => {
    setChecked(!checked);
  };
  const handleChange = () => {
    setCheckedOne(!checkedOne);
  };
  const handleChangeEmail = () => {
    setCheckedTwo(!checkedTwo);
  };
  const handleChangeForm = () => {
    setCheckedThree(!checkedThree);
  };
  const handleChangePhysical = () => {
    setCheckedFour(!checkedFour);
  };
  const state_data = [
    { label: "Rajasthan", value: "Rajasthan" },
    { label: "Punjab", value: "Punjab" },
    { label: "Haryana", value: "Haryana" },
    { label: "Kerla", value: "Kerla" },
    { label: "Delhi", value: "Delhi" },
  ];
  const city_data = [
    { label: "Ambala", value: "Ambala" },
    { label: "Nanital", value: "Nanital" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Jaipur", value: "Jaipur" },
    { label: " New Delhi", value: "New Delhi" },
  ];
  const country_data = [
    { label: "India", value: "India" },
    { label: "Australia", value: "Australia" },
    { label: "England", value: "England" },
    { label: "New Zealand", value: "New Zealand" },
    { label: " South Africa", value: "South Africa" },
  ];
  const module_data = [
    { label: "Endorsement", value: "Endorsement" },
    { label: "Claim", value: "Claim" },
  ];
  const physical_product_data = [
    { key: "Group Health", value: "Group Health" },
    { key: "Group Term", value: "Group Term" },
    { key: "Group Travel", value: "Group Travel" },
  ];
  const physical_type_data = [
    { key: "Claim", value: "Claim" },
    { key: "Claim", value: "Claim" },
  ];
  const physical_subtype_data = [
    { key: "Cashless", value: "Cashless" },
    { key: "Cashless", value: "Cashless" },
  ];
  const handleClicked = () => {
    setToggle(true);
  };
  const handleClick = () => {
    setToggle(false);
  };
  // const updateMasterState = (
  //   attrName: any,
  //   value: string | boolean | number
  // ) => {
  //   attrName(value);
  // };

  // for scrolling
  const personalDetails = useRef(null);
  const address = useRef(null);
  const singlecontact = useRef(null);
  const locations = useRef(null);
  const emailtemp = useRef(null);
  const formtemp = useRef(null);
  const basicinfo = useRef(null);
  const ageband = useRef(null);
  const physicalform = useRef(null);

  const scrollToSection = (elementRef: any) => {
    // debugger;
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };

  // const [file, setFile] = useState();

  // function handleChange(e: any) {
  //   console.log(e.target.files);
  //   setFile(URL.createObjectURL(e.target.files[0]));
  // }
  return (
    <Box className="layoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate("/homebroker?page=productConfig");
            }}
          >
            <ChevronLeftIcon />
          </Link>
          <span className="detailIcon">D</span>
          <div>
            <h3>Digit</h3>
          </div>
        </Grid>
        <Grid
          xs={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          <div>
            <Tooltip title="Global Edit">
              <Link
                className="actionLinks"
                onClick={() => {
                  navigate("/homebroker");
                }}
              >
                <BorderColorIcon />
              </Link>
            </Tooltip>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection h-100">
              <Link
                className={
                  sectionStatus === "personalDetails"
                    ? "active sectionLink personalDetails"
                    : "sectionLink personalDetails"
                }
                onClick={() => {
                  scrollToSection(personalDetails);
                  SetSectionStatus("personalDetails");
                }}
              >
                <span> Basic Info</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "basicinfo"
                        ? "inner_link active basicinfo"
                        : "inner_link basicinfo"
                    }
                    onClick={() => {
                      setSubSection("basicinfo");
                      handleClicks(subSection);
                      scrollToSection(basicinfo);
                    }}
                  >
                    Basic info
                  </Link>
                </li>
                <li>
                  <Link
                    className={
                      subSection === "address"
                        ? "inner_link active address"
                        : "inner_link address"
                    }
                    onClick={() => {
                      setSubSection("address");
                      handleClicks(subSection);
                      scrollToSection(address);
                    }}
                  >
                    Address Details
                  </Link>
                </li>
              </ul>
              <Link
                className={
                  sectionStatus === "ageband"
                    ? "active sectionLink ageband"
                    : "sectionLink ageband"
                }
                onClick={() => {
                  handleClicks(ageband);
                  scrollToSection(ageband);
                  SetSectionStatus("ageband");
                }}
              >
                <span>Age Band for Children</span>
              </Link>
              <Link
                className={
                  sectionStatus === "singlecontact"
                    ? "active sectionLink singlecontact"
                    : "sectionLink spoc"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(singlecontact);
                  SetSectionStatus("singlecontact");
                }}
              >
                <span>Single Person of Contact</span>
              </Link>

              <Link
                className={
                  sectionStatus === "emailtemp"
                    ? "active sectionLink emailtemp"
                    : "sectionLink emailtemp"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(emailtemp);
                  SetSectionStatus("emailtemp");
                }}
              >
                <span>Email Templates</span>
              </Link>

              <Link
                className={
                  sectionStatus === "formtemp"
                    ? "active sectionLink formtemp"
                    : "sectionLink formtemp"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(formtemp);
                  SetSectionStatus("formtemp");
                }}
              >
                <span> Form Templates</span>
              </Link>
              <Link
                className={
                  sectionStatus === "physicalform"
                    ? "active sectionLink physicalform"
                    : "sectionLink physicalform"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(physicalform);
                  SetSectionStatus("physicalform");
                }}
              >
                <span>Physical Forms</span>
              </Link>
            </Grid>
            <Grid xs className="rightSection h-100">
              <Grid container spacing={3} alignItems="center">
                <Grid lg={7} md={7} xs={12} className="pl-0">
                  <div className="productTabs ">
                    <Button
                      className={
                        viewTabsStatus == "overview"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "overview");
                      }}
                    >
                      Overview
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "location"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "location");
                      }}
                    >
                      locations
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "networkhospital"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "networkhospital");
                      }}
                    >
                      Network Hospitals
                    </Button>
                  </div>
                </Grid>
                <Grid
                  lg={5}
                  md={5}
                  xs={12}
                  style={{ textAlign: "right" }}
                  className="text-sm-center"
                >
                  {/* <p className="lastupdate">
                    Last Update: 11:00AM, 10th Nov, 2022
                  </p> */}
                </Grid>
              </Grid>
              {viewTabsStatus == "overview" ? (
                <>
                  <Box className="detailSection" ref={personalDetails}>
                    <div className="sectionTitle mb-0">
                      <h4>Basic Info</h4>
                      <div className="actionBtns">
                        <Link
                          className="blueBtn edit"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Edit
                        </Link>
                      </div>
                    </div>
                    <div ref={basicinfo}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Basic info</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3} alignItems="center">
                        <Grid xs={6} sx={{ paddingBottom: "16px" }}>
                          <Button
                            className="add_logo greenBtn addfile"
                            component="label"
                          >
                            <input
                              hidden
                              accept="image/*"
                              multiple
                              type="file"
                              onChange={handleChange}
                            />
                            <span>Add Logo</span>
                            <img src={file} className="uploadimage" />
                          </Button>

                          <Link className="editlogo">Change Logo</Link>
                        </Grid>
                        <Grid xs={6} textAlign="right">
                          {/* <Link  className="networkhosp">
                            Network Hospitals
                          </Link> */}
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextField
                            class_name="inputField"
                            title="Insurer Name"
                            value={insurerName}
                            attrName={setInsurerName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextField
                            class_name="inputField"
                            title="No. Of Hospital"
                            value={networkhospurl}
                            attrName={setNetworkHospUrl}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={3}>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextField
                            class_name="inputField"
                            title="Website"
                            value={website}
                            attrName={setWebsite}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextField
                            class_name="inputField"
                            title="Email"
                            value={personalemail}
                            attrName={setPersonalEmail}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextField
                            class_name="inputField"
                            title="Contact Number"
                            value={mobilenumber}
                            attrName={setMobileNumber}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                    <div ref={address}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">
                            Head Office Address Details
                          </h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={6} lg={6} xl={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Location Name"
                            value={locationName}
                            attrName={setLocationName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={6} xl={6}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Type"
                            value={location}
                            attrName={setLocation}
                            value_update={updateMasterState}
                            data={location_data}
                            warn_status={false}
                            error_message="Please select Location"
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={6} lg={6} xl={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Building/Street Name"
                            value={buildingName}
                            attrName={setBuildingName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={6} xl={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Area Name"
                            value={areaName}
                            attrName={setAreaName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Country"
                            value={country}
                            attrName={setCountry}
                            value_update={updateMasterState}
                            data={country_data}
                            warn_status={false}
                            error_message="Please select"
                          />
                        </Grid>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="State"
                            value={State}
                            attrName={setState}
                            value_update={updateMasterState}
                            data={state_data}
                            warn_status={false}
                            error_message="Please select"
                          />
                        </Grid>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="City"
                            value={City}
                            attrName={setCity}
                            value_update={updateMasterState}
                            data={city_data}
                            warn_status={false}
                            error_message="Please select"
                          />
                        </Grid>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Zipcode"
                            value={zipcode}
                            attrName={setZipcode}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Box>
                  <Box className="detailSection" ref={ageband}>
                    <div className="sectionTitle mb-0">
                      <h4>Age Band for Children</h4>
                    </div>
                    <Grid container spacing={3} className="mt-2">
                      <Grid xs={6} md={6} lg={4} xl={2}>
                        <SelectDropdown
                          class_name="inputField"
                          title="Select Minimum Age"
                          value={minimumAge}
                          attrName={setMinimumAge}
                          value_update={updateMasterState}
                          dropdown_data={minimumage_data}
                          warn_status={false}
                        />
                      </Grid>

                      <Grid xs={6} md={6} lg={4} xl={2}>
                        <SelectDropdown
                          class_name="inputField"
                          title="Select Maximum Age"
                          value={maximumAge}
                          attrName={setMaximumAge}
                          value_update={updateMasterState}
                          dropdown_data={maximumage_data}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <Box className="detailSection" ref={singlecontact}>
                    <div className="sectionTitle mb-3">
                      <h4>Single Person of Contact</h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          onClick={() => {
                            setOpenContactForm(true);
                          }}
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Add Contact
                        </Link>
                        <Link
                          className="redBtn delete"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Delete
                        </Link>
                      </div>
                    </div>
                    <SpocTable />
                  </Box>

                  <Box className="detailSection" ref={emailtemp}>
                    <div className="sectionTitle mb-0">
                      <h4>Email Templates</h4>
                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          onClick={() => {
                            setopenEmail(true);
                          }}
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Add Template
                        </Link>
                        <Link
                          className="redBtn delete"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Delete
                        </Link>
                      </div>
                    </div>
                    <div className="table">
                      <div className="common-table">
                        <ul className="heading">
                          <li>
                            Sr.
                            <button className="sorting-btn"></button>
                          </li>
                          <li>
                            Title
                            <button className="sorting-btn"></button>
                          </li>
                          <li>
                            Subject
                            <button className="sorting-btn"></button>
                          </li>
                          <li>
                            Actions
                            <button className="sorting-btn mr-0"></button>
                          </li>
                        </ul>

                        {emailData.map((data, index) => (
                          <ul className="subheading">
                            <li>{data.sr_no}</li>
                            <li>{data.Title}</li>
                            <li>{data.subject}</li>
                            <li>
                              <Link className="edit_address_link">
                                <img src={data.actionBtn} alt="" />
                              </Link>
                            </li>
                          </ul>
                        ))}
                      </div>
                    </div>
                  </Box>

                  <Box className="detailSection" ref={formtemp}>
                    <div className="sectionTitle">
                      <h4>Endorsment Form Templates</h4>
                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Add Template
                        </Link>
                        <Link
                          className="redBtn delete"
                          onClick={() => {
                            setRemoveCategory(true);
                          }}
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Delete
                        </Link>
                      </div>
                    </div>
                    <Grid container>
                      <Grid xs={12}>
                        <div className="table">
                          <div className="common-table">
                            <ul className="heading mb-0">
                              <li>
                                <div
                                  className="Checkbox"
                                  onClick={handleChangeForm}
                                >
                                  <input type="checkbox" name="check" />
                                  <label className="employee"></label>
                                </div>
                                Sr.
                                <button className="sorting-btn"></button>
                              </li>
                              <li>
                                Title
                                <button className="sorting-btn"></button>
                              </li>
                              <li>
                                Description
                                <button className="sorting-btn"></button>
                              </li>
                              <li>
                                Actions
                                <button className="sorting-btn mr-0"></button>
                              </li>
                            </ul>

                            {formData.map((data, index) => (
                              <ul className="subheading">
                                <li>
                                  <div className="Checkbox">
                                    {checkedThree == true ? (
                                      <input
                                        type="checkbox"
                                        name="check"
                                        checked={checkedThree}
                                      />
                                    ) : (
                                      <input type="checkbox" name="check" />
                                    )}
                                    <label className="employee"></label>
                                  </div>
                                  {data.sr_no}
                                </li>
                                <li>{data.Title}</li>
                                <li>{data.description}</li>
                                <li>
                                  <Link className="edit_address_link">
                                    <img src={data.actionBtn} alt="" />
                                  </Link>
                                </li>
                              </ul>
                            ))}
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </Box>

                  <Box className="detailSection lastsection" ref={physicalform}>
                    <div className="sectionTitle">
                      <h4>Physical Forms</h4>
                      <div className="actionBtns">
                        <Link
                          className="blueBtn replace_icon"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Replace
                        </Link>
                        <Link
                          className="redBtn delete"
                          onClick={() => {
                            setRemoveCategory(true);
                          }}
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Delete
                        </Link>
                        <Link
                          className="blueBtn view"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          View
                        </Link>
                        <Link
                          className="blueBtn addfile"
                          onClick={() => {
                            setOpenPhysicalForm(true);
                          }}
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Add Form
                        </Link>
                      </div>
                    </div>
                    <Grid container>
                      <Grid xs={12}>
                        <div className="table">
                          <div className="physical-table">
                            <ul className="heading mb-0">
                              <li>
                                <div
                                  className="Checkbox"
                                  onClick={handleChangePhysical}
                                >
                                  <input type="checkbox" name="check" />
                                  <label className="employee"></label>
                                </div>
                                Title
                                <button className="sorting-btn"></button>
                              </li>
                              <li>
                                Description
                                <button className="sorting-btn"></button>
                              </li>
                              <li>
                                Product
                                <button className="sorting-btn"></button>
                              </li>
                              <li>
                                Type
                                <button className="sorting-btn"></button>
                              </li>
                              <li>
                                Sub-Type
                                <button className="sorting-btn"></button>
                              </li>
                              <li>
                                Action
                                <button className="sorting-btn"></button>
                              </li>
                            </ul>

                            {physicalData.map((data, index) => (
                              <ul className="subheading">
                                <li>
                                  <div className="Checkbox">
                                    {checkedFour == true ? (
                                      <input
                                        type="checkbox"
                                        name="check"
                                        checked={checkedFour}
                                      />
                                    ) : (
                                      <input type="checkbox" name="check" />
                                    )}
                                    <label className="employee"></label>
                                  </div>
                                  {data.Title}
                                </li>
                                <li>{data.description}</li>
                                <li>{data.product}</li>
                                <li>{data.type}</li>
                                <li>{data.subtype}</li>
                                <li>
                                  <Link className="edit_address_link">
                                    <img src={data.actionBtn} alt="" />
                                  </Link>
                                </li>
                              </ul>
                            ))}
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </Box>
                </>
              ) : null}
              {viewTabsStatus == "location" ? (
                <>
                  <Box className="detailSection" ref={locations}>
                    <div className="sectionTitle mb-0">
                      <h4>Locations</h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          onClick={() => {
                            setopenLocation(true);
                          }}
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Add Location
                        </Link>
                      </div>
                    </div>
                    <LocationDetail
                      open_status={locationDetail}
                      attrName={setLocationDetail}
                      value_update={updateMasterState}
                    />
                  </Box>

                  {/* location TAble */}
                  <LocationTable />
                </>
              ) : null}
              {viewTabsStatus == "networkhospital" ? <></> : null}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={3} className="footerSection">
        <Grid xs={12} className="ctaBtn">
          <Button variant="outlined" className="borderBtn">
            Cancel
          </Button>
          <Button variant="outlined" className="borderBtn">
            Save Draft
          </Button>
          <Button variant="contained" className="submitBtn">
            Save & Continue
          </Button>
        </Grid>
      </Grid>
      <SlidingPanel type={"right"} isOpen={openEmail} size={75}>
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-4 ml-0">New Email Template</h4>
            </Grid>
            <Grid xs={2} textAlign="end" className="mt-3">
              <GridCloseIcon
                onClick={() => {
                  setopenEmail(false);
                }}
              />
            </Grid>
            <Grid xs={12} className="pt-0 mb-4">
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area">
            {/* <div className="locations_section"> */}
            <Grid container spacing={3}>
              <Grid xs={6} md={6} lg={6} xl={6}>
                <RKTextField
                  class_name="inputField"
                  title="Template Title"
                  value={templateTitle}
                  attrName={setTemplateTitle}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={6} md={6} lg={6} xl={6}>
                <SearchDropdown
                  class_name="inputField"
                  title="Module"
                  value={module}
                  attrName={setModule}
                  value_update={updateMasterState}
                  data={module_data}
                  warn_status={false}
                  error_message="Please select module"
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid xs={12} md={12} lg={12} xl={12}>
                <RKTextField
                  class_name="inputField"
                  title="Subject"
                  value={subjects}
                  attrName={setSubjects}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid xs={12} md={12} lg={12} xl={12}>
                <RKTextField
                  class_name="inputField"
                  title="Respondent’s Email Id"
                  value={respondent}
                  attrName={setRespondent}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid xs={12} md={12} lg={12} xl={12}>
                <RKTextField
                  class_name="inputField"
                  title="Sender’s Email Id"
                  value={senderEmail}
                  attrName={setSenderEmail}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid
                xs={12}
                className="switchFields pl-4"
                display={"flex"}
                alignItems="center"
              >
                <span className="mr-3">Want to add attachment ?</span>
                <input
                  type="checkbox"
                  className="switch"
                  onClick={() => setShow(!show)}
                />
              </Grid>
            </Grid>
            {show && (
              <Grid
                container
                spacing={0}
                justifyContent="center"
                className="mt-4 mb-4"
              >
                <Grid xs={10} className="inputField uploadFile">
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Add Attatchment"
                    variant="outlined"
                    className="textarea"
                  />
                </Grid>
                <Grid xs={2}>
                  <Button variant="contained" className="browsebtn w-100">
                    Browse
                  </Button>
                </Grid>
              </Grid>
            )}

            <Grid container spacing={3}>
              <Grid xs={12} md={12} lg={12} xl={12} className="inputField">
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="body"
                  variant="outlined"
                  className="textarea"
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid xs={12} className="mb-4">
                <p>Describe here</p>
                <textarea
                  className="textareabox"
                  placeholder="Writing here..."
                ></textarea>
              </Grid>
            </Grid>
          </div>
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn mt-4">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {
                  setopenEmail(false);
                }}
              >
                Add Tempalte
              </Button>
            </Grid>
          </Grid>
        </div>
      </SlidingPanel>
      <SlidingPanel type={"right"} isOpen={openLocation} size={75}>
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-4 ml-0">Location Details</h4>
            </Grid>
            <Grid xs={2} textAlign="end" className="mt-3">
              <GridCloseIcon
                onClick={() => {
                  setopenLocation(false);
                }}
              />
            </Grid>
            <Grid xs={12} className="pt-0 mb-3">
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area pt-2">
            <div className="locations_section">
              <Grid container spacing={3}>
                <Grid xs={6} md={6} lg={6} xl={6}>
                  <RKTextField
                    class_name="inputField"
                    title="Location Name"
                    value={locationName}
                    attrName={setLocationName}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6} md={6} lg={6} xl={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Type"
                    value={location}
                    attrName={setLocation}
                    value_update={updateMasterState}
                    data={location_data}
                    warn_status={false}
                    error_message="Please select Location"
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid xs={6} md={6} lg={6} xl={6}>
                  <RKTextField
                    class_name="inputField"
                    title="Building/Street Name"
                    value={buildingName}
                    attrName={setBuildingName}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6} md={6} lg={6} xl={6}>
                  <RKTextField
                    class_name="inputField"
                    title="Area Name"
                    value={areaName}
                    attrName={setAreaName}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid sm={6} md={4} lg={3} xl={3}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Country"
                    value={country}
                    attrName={setCountry}
                    value_update={updateMasterState}
                    data={country_data}
                    warn_status={false}
                    error_message="Please select"
                  />
                </Grid>
                <Grid sm={6} md={4} lg={3} xl={3}>
                  <SearchDropdown
                    class_name="inputField"
                    title="State"
                    value={State}
                    attrName={setState}
                    value_update={updateMasterState}
                    data={state_data}
                    warn_status={false}
                    error_message="Please select"
                  />
                </Grid>
                <Grid sm={6} md={4} lg={3} xl={3}>
                  <SearchDropdown
                    class_name="inputField"
                    title="City"
                    value={City}
                    attrName={setCity}
                    value_update={updateMasterState}
                    data={city_data}
                    warn_status={false}
                    error_message="Please select"
                  />
                </Grid>
                <Grid sm={6} md={4} lg={3} xl={3}>
                  <RKTextField
                    class_name="inputField"
                    title="Zipcode"
                    value={zipcode}
                    attrName={setZipcode}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} alignItems="center">
                <Grid xs={12} className="mb-0 pb-0">
                  <h6 className="popup-subheading">Location Details</h6>
                </Grid>

                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Select Contact"
                    value={contactID}
                    attrName={setContactID}
                    value_update={updateMasterState}
                    data={ContactID_data}
                    warn_status={false}
                    error_message="Please select"
                  />
                </Grid>
              </Grid>
            </div>
          </div>
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn mt-4">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {
                  setopenLocation(false);
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </div>
      </SlidingPanel>
      <SlidingPanel
        type={"right"}
        isOpen={openContactForm}
        size={75}
        // backdropClicked={() => {
        //   setOpenContactForm(false);
        // }}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-4 ml-0">SPOC Details</h4>
            </Grid>
            <Grid xs={2} textAlign="end" className="mt-3">
              <GridCloseIcon
                onClick={() => {
                  setOpenContactForm(false);
                }}
              />
            </Grid>
            <Grid xs={12} className="pt-0">
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area">
            <Grid container spacing={3} className="mt-3">
              <Grid xs={7}>
                <SelectDropdown
                  class_name="inputField"
                  title="Select Contact"
                  value={spocContact}
                  attrName={setSpocContact}
                  value_update={updateMasterState}
                  dropdown_data={spoc_contact_data}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={5} className="mt-2" style={{ textAlign: "right" }}>
                <Link
                  className="greenBtn addfile"
                  underline="none"
                  onClick={() => {
                    navigate("/AddNewContact");
                  }}
                >
                  Create New Contact
                </Link>
              </Grid>
              {spocContact === "EV0065VikasSaini" ||
              spocContact === "EV0016KartikeKakkar" ? (
                <>
                  <Grid xs={6}>
                    <RKTextField
                      class_name="inputField"
                      title="Name"
                      value={contactName}
                      attrName={setContactName}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Organization"
                      value={contactOrganization}
                      attrName={setContactOrganization}
                      value_update={updateMasterState}
                      dropdown_data={contact_organization_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Department"
                      value={contactDepartment}
                      attrName={setContactDepartment}
                      value_update={updateMasterState}
                      dropdown_data={contact_department_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Current Job Title"
                      value={jobTitle}
                      attrName={setJobTitle}
                      value_update={updateMasterState}
                      dropdown_data={job_title_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Current Employer"
                      value={currentEmployer}
                      attrName={setCurrentEmployer}
                      value_update={updateMasterState}
                      dropdown_data={current_employer_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <RKTextField
                      class_name="inputField"
                      title="Email"
                      value={contactEmail}
                      attrName={setContactEmail}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <RKTextField
                      class_name="inputField"
                      title="Mobile"
                      value={contactMobile}
                      attrName={setContactMobile}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <RKTextField
                      class_name="inputField"
                      title="Contact number"
                      value={contactNumber}
                      attrName={setContactNumber}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                </>
              ) : null}
            </Grid>
          </div>
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn mt-4">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {}}
              >
                Add SPOC
              </Button>
            </Grid>
          </Grid>
        </div>
      </SlidingPanel>
      <SlidingPanel
        type={"right"}
        isOpen={openPhysicalForm}
        size={75}
        // backdropClicked={() => {
        //   setOpenPhysicalForm(false);
        // }}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-4 ml-0">Add New Form</h4>
            </Grid>
            <Grid xs={2} textAlign="end" className="mt-3">
              <GridCloseIcon
                onClick={() => {
                  setOpenPhysicalForm(false);
                }}
              />
            </Grid>
            <Grid xs={12} className="pt-0 mb-4">
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area">
            {/* <div className="locations_section"> */}
            <Grid container spacing={3}>
              <Grid xs={7}>
                <RKTextField
                  class_name="inputField"
                  title="Title"
                  value={physicalTitle}
                  attrName={setPhysicalTitle}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={5}>
                <SelectDropdown
                  class_name="inputField"
                  title="Product"
                  value={physicalProduct}
                  attrName={setPhysicalProduct}
                  value_update={updateMasterState}
                  dropdown_data={physical_product_data}
                  warn_status={false}
                />
              </Grid>

              <Grid xs={12} className="mb-0">
                <p className="description">Description</p>
                <textarea
                  className="textareabox"
                  placeholder="Writing here..."
                ></textarea>
              </Grid>
              <Grid xs={6}>
                <SelectDropdown
                  class_name="inputField"
                  title="Type"
                  value={physicalType}
                  attrName={setPhysicalType}
                  value_update={updateMasterState}
                  dropdown_data={physical_type_data}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={6}>
                <SelectDropdown
                  class_name="inputField"
                  title="Sub Type"
                  value={physicalsubType}
                  attrName={setPhysicalSubType}
                  value_update={updateMasterState}
                  dropdown_data={physical_subtype_data}
                  warn_status={false}
                />
              </Grid>
            </Grid>

            <Grid
              container
              spacing={0}
              justifyContent="center"
              className="mt-4 mb-4"
            >
              <Grid xs={10} className="inputField uploadFile">
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Add Attatchment"
                  variant="outlined"
                  className="textarea"
                />
              </Grid>
              <Grid xs={2}>
                <Button
                  variant="contained"
                  className="browsebtn"
                  component="label"
                >
                  Browse
                  <input hidden accept="image/*" multiple type="file" />
                </Button>
              </Grid>
              <Grid xs={12}>
                <p className="fileUploadTypeDetails">
                  Files may be upto 50 MB, and .xls, .xlsx, .csv or .vcf formats
                </p>
              </Grid>
            </Grid>
          </div>
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn mt-4">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {
                  setOpenPhysicalForm(false);
                }}
              >
                Add Form
              </Button>
            </Grid>
          </Grid>
        </div>
      </SlidingPanel>
      {/*  <Modal open={deleteStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                
                className="close-button"
                onClick={() => {
                  setDeleteStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link  className="md-link" underline="none">
                You are about to Delete this Attatchment.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <Modal open={removeStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                
                className="close-button"
                onClick={() => {
                  setRemoveStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link  className="md-link" underline="none">
                You are want to remove this Contacts.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal> */}
    </Box>
  );
}
export default InsurerDetails;
